import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    GET_TYPING_USERS_REQUEST,
    SET_USERS
} from '../actions/users';
import { buildUsers } from '../helpers/users';
const initialState = {
    fetching: false,
    users: [],
    total: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_TYPING_USERS_REQUEST: {
            return {
                ...state,
                fetching: true,
                users: [],
                total: 0
            };
        }
        case GET_USERS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                users: state.users.concat(buildUsers(action.payload.users, action.payload.profiles)),
                total: (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total
            };
        }
        case GET_USERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_USERS: {
            return {
                ...state,
                users: action.payload.users,
                total: action.payload.total
            };
        }

        default:
            return state;
    }
};
